import React from 'react';
import { ReactComponent as ErrorSettingsIcon } from '~/src/static/error-settings-icon.svg';
import ClioLogo from '@clio/design-system-web-components/react/logo';

const handleReload = () => {
  window.location.reload();
};

const handleGoToLibrary = () => {
  window.location.href = '/';
};

const ErrorFallback = () => (
  <div
    className="flex min-h-screen w-full flex-col items-center justify-center bg-gray-50 px-4 text-center"
    role="alert"
    aria-live="assertive"
  >
    {/* Logo */}
    <div className="mb-12 flex items-center">
      <ClioLogo product="draft" className="h-8" />
    </div>

    <div className="flex w-full max-w-md flex-col items-center space-y-8">
      {/* Icon */}
      <div className="flex items-center justify-center">
        <ErrorSettingsIcon className="h-20 w-20" aria-hidden="true" />
      </div>

      {/* Text Content */}
      <div className="space-y-3">
        <h1 className="text-2xl font-semibold text-gray-900 sm:text-3xl">
          We&apos;re having trouble loading this page.
        </h1>
        <p className="text-base leading-relaxed text-gray-600">
          An unexpected error occurred on our end. We&apos;ve been notified and
          are working to fix it.
        </p>
      </div>

      {/* CTAs */}
      <div className="flex w-full flex-col gap-3 pt-2 sm:flex-row sm:justify-center">
        <button
          type="button"
          onClick={handleReload}
          className="w-full rounded-md bg-blue-600 px-8 py-2.5 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:w-auto"
          aria-label="Try again by reloading the page"
        >
          Try Again
        </button>
        <button
          type="button"
          onClick={handleGoToLibrary}
          className="w-full rounded-md border border-gray-300 bg-white px-8 py-2.5 text-base font-medium text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:w-auto"
          aria-label="Go to Library"
        >
          Go to Library
        </button>
      </div>

      {/* Support link */}
      <p className="text-sm text-gray-500">
        <a
          href="mailto:support@clio.com"
          className="transition-colors hover:text-blue-600 hover:underline"
          tabIndex={0}
        >
          Contact support
        </a>{' '}
        if the problem persists.
      </p>
    </div>
  </div>
);

export default ErrorFallback;
